import { Box, Flex, Text } from '@chakra-ui/react'
import { maskPhone } from '../../../utils/maskPhone'

export function Consultor({ consultor }) {
    return (
        <Box
            gridColumn={{
                base: 'span 12',
                md: 'span 4',
            }}
            border="1px solid #cfcfcf"
        >
            <Text textAlign="center" color="#1D1D1D" bg="#cfcfcf">
                Seu Consultor
            </Text>

            <Flex flexDir="column" gap={1} p={3}>
                <Text>
                    <b>Nome:</b> {consultor.nome}
                </Text>
                <Text>
                    <b>Telefone:</b> {maskPhone(consultor.fixo_vendedor)}
                </Text>
                <Text>
                    <b>Celular</b>: {maskPhone(consultor.celular_vendedor)}
                </Text>
                <Text>
                    <b>Email:</b> {consultor.email_vendedor}
                </Text>
            </Flex>
        </Box>
    )
}
